import React from "react";
import { render } from "react-dom";
import NextBus from "./components/NextBus";

if (document.getElementsByClassName("next-bus-widget")) {
  const el = [].slice.call(document.getElementsByClassName("next-bus-widget"));
  el.forEach(e => {
    render(<NextBus />, e);
  });
}
